import { mapState, mapActions, mapGetters } from "vuex";
import AppIcon from "@/components/AppIcon";
import Tacos from "@/components/brand_portfolio/Tacos";
import Roas from "@/components/brand_portfolio/Roas";
import AccountsMixin from "@/mixins/AccountsMixin.vue";
import ChevronDownIcon from "@/components/icons/ChevronDownIcon.vue";
import ChevronRightIcon from "@/components/icons/ChevronRightIcon.vue";
import AppPopover from "@/components/AppPopover";
import LoadingElement from "@/components/shared/LoadingElement.vue";
import CurrencyValue from "@/components/tableElements/CurrencyValue.vue";
import PercentageValue from "@/components/tableElements/PercentageValue.vue";
import { resetLocalStorage } from "@/utils/storage";
import { EVENTS } from "@/utils";
import AppDropdown from "@/components/AppDropdown.vue";
import { country_codes_with_flags_and_marketplace_ids } from "@/utils/countries";
import SpendBar from "@/components/brand_portfolio/SpendBar.vue";
import BrandPortfolioSellerNameCell from "@/components/brand_portfolio/BrandPortfolioSellerNameCell.vue";
import BrandPortfolioTrendingCell from "@/components/brand_portfolio/BrandPortfolioTrendingCell.vue";
import BrandPortfolioRevenueCell from "@/components/brand_portfolio/BrandPortfolioRevenueCell.vue";
import BrandPortfolioTacosCell from "@/components/brand_portfolio/BrandPortfolioTacosCell.vue";
import BrandPortfolioRoasCell from "@/components/brand_portfolio/BrandPortfolioRoasCell.vue";
import BrandPortfolioSpendCell from "./BrandPortfolioSpendCell.vue";
export default {
  name: "BrandPortfolioChildrenRow",
  components: {
    AppIcon,
    Tacos,
    Roas,
    ChevronDownIcon,
    ChevronRightIcon,
    AppPopover,
    LoadingElement,
    AppDropdown,
    CurrencyValue,
    PercentageValue,
    SpendBar,
    BrandPortfolioSellerNameCell,
    BrandPortfolioTrendingCell,
    BrandPortfolioRevenueCell,
    BrandPortfolioTacosCell,
    BrandPortfolioRoasCell,
    BrandPortfolioSpendCell
  },
  mixins: [AccountsMixin],
  emits: ["onWorkspaceRowClickHandler", "onWorkspaceNameClickHandler", "onWorkspaceAlertClickHandler"],
  props: {
    loading: {
      type: Boolean,
      default: false
    },
    portfolio: {
      type: Object,
      default: {}
    },
    periodLength: {
      type: Number,
      default: 14
    },
    period_data: {
      type: Object,
      default: {}
    },
    selected_period: {
      type: String,
      default: "weekly"
    },
    isLastSellerInWorkspace: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {};
  },
  computed: {
    ...mapState({
      brand_portfolio: state => state.brand_portfolio.list,
      parent_workspace_to_child_workspace_map: state => state.brand_portfolio.parent_workspace_to_child_workspace_map,
      sellers_filter: state => state.brand_portfolio.sellers_filter,
      accounts: state => state.account.list,
      workspaces: state => state.workspace.list,
      isOmnyUser: state => state.auth.isOmnyUser
    }),
    ...mapGetters(["getCountryFlag"])
  },
  mounted() {},
  methods: {
    onWorkspaceRowClickHandler() {
      this.$emit("onWorkspaceRowClickHandler", this.portfolio);
    },
    onSellerNameClickHandler(workspace_id, seller_id) {
      this.$emit("onSellerNameClickHandler", workspace_id, seller_id);
    },
    onWorkspaceAlertClickHandler(workspace_id) {
      this.$emit("onWorkspaceAlertClickHandler", workspace_id);
    }
  }
};